import React from 'react';

import { ProgressContainer, ProgressDot } from './ProgressIndicator.styled';

import { debounceEvent } from 'pubweb-smokey/dist/utils/utils';

class ProgressIndicator extends React.Component {
  constructor() {
    super();

    this.state = {
      viewportHeight: null,
      sectionsScrolled: 0,
    };

    this.handleScroll = this.handleScroll.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.debounceWindowSizer = debounceEvent(
      this.getWindowSize.bind(this),
      200
    );
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.debounceWindowSizer); // adding this listener for IE/Edge
    }
    this.getWindowSize();
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.debounceWindowSizer);
    }
  }

  getWindowSize() {
    if (typeof window !== 'undefined') {
      const windowHeight =
        window.innerHeight < window.screen.availHeight
          ? window.innerHeight
          : window.screen.availHeight;

      this.setState({
        viewportHeight: windowHeight - 90, //90px fixed position header compensation
      });
    }
  }

  handleScroll() {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      const scrollAmount =
        window.pageYOffset || document.documentElement.scrollTop;
      const sectionsScrolled = Math.floor(
        scrollAmount / this.state.viewportHeight
      );

      if (sectionsScrolled !== this.state.sectionsScrolled) {
        this.setState({
          sectionsScrolled: sectionsScrolled,
        });
      }
    }
  }

  handleClick(section) {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      const supportsNativeSmoothScroll =
        'scrollBehavior' in document.documentElement.style;
      const top = this.state.viewportHeight * section + 92;
      if (supportsNativeSmoothScroll) {
        //   this if stmt is an IE/Edge fix they don't support options on window.scroll
        window.scroll({ top, behavior: 'smooth' });
      } else {
        window.scroll(0, top);
      }
    }
  }

  render() {
    return (
      <ProgressContainer>
        <ProgressDot
          onClick={() => this.handleClick(0)}
          active={this.state.sectionsScrolled === 0}
        >
          {' '}
        </ProgressDot>
        <ProgressDot
          onClick={() => this.handleClick(1)}
          active={this.state.sectionsScrolled === 1}
        >
          {' '}
        </ProgressDot>
        <ProgressDot
          onClick={() => this.handleClick(2)}
          active={this.state.sectionsScrolled === 2}
        >
          {' '}
        </ProgressDot>
        <ProgressDot
          onClick={() => this.handleClick(3)}
          active={this.state.sectionsScrolled === 3}
        >
          {' '}
        </ProgressDot>
        <ProgressDot
          onClick={() => this.handleClick(4)}
          active={this.state.sectionsScrolled === 4}
        >
          {' '}
        </ProgressDot>
        <ProgressDot
          onClick={() => this.handleClick(5)}
          active={this.state.sectionsScrolled === 5}
        >
          {' '}
        </ProgressDot>
        <ProgressDot
          onClick={() => this.handleClick(6)}
          active={this.state.sectionsScrolled === 6}
        >
          {' '}
        </ProgressDot>
        <ProgressDot
          onClick={() => this.handleClick(7)}
          active={this.state.sectionsScrolled >= 7}
        >
          {' '}
        </ProgressDot>
      </ProgressContainer>
    );
  }
}

export default ProgressIndicator;
